import { useEffect, useState } from 'react';
import { FormLabel } from 'ui/formField';
import { Person } from 'ui/icons';
import { Avatar, AVATAR_COLORS, AVATAR_SIZES } from 'ui/avatar';
import { displayContent } from 'modules/templateEditor/common';
import { useSmsSmartOptInContext } from './contexts/SmsSmartOptInContext';
import {
  deviceContainer,
  messageBody,
  messageBodyMessageLabelResponder,
  messageBodyMessageLabelSender,
  messageBodyMessageResponder,
  messageBodyMessageSender,
  messageHeader,
  messageHeaderCenter,
  PreviewContent,
} from './SmsSmartOptIn.styled';

// Optional until provided by API
type PreviewProps = {
  optInMessage?: string;
  legalDisclaimerMessage?: string;
};

// Mock placeholder messages until provided API
export const OPT_IN_MESSAGE =
  'Send in this text to opt in to receiving recurring automated personalized marketing alerts from {{brandName}} (itbl: gY3-4)';
export const OPT_IN_LEGAL_DISCLAIMER_REPLY =
  'Welcome! Msg & data rates may apply. Msg frequency varies. Reply HELP for help, STOP to cancel. Privacy: {{sms_privacy}}';

export const SmsSmartOptInPreview = ({
  optInMessage = OPT_IN_MESSAGE,
  legalDisclaimerMessage = OPT_IN_LEGAL_DISCLAIMER_REPLY,
}: PreviewProps) => {
  const { assetDetails: smartLink } = useSmsSmartOptInContext();
  const { brandName } = smartLink;
  const [brandedOptInMessage, setBrandedOptInMessage] = useState(
    brandName ? optInMessage.replace('{{brandName}}', brandName) : optInMessage,
  );

  useEffect(() => {
    if (brandName) {
      setBrandedOptInMessage(optInMessage.replace('{{brandName}}', brandName));
    } else {
      setBrandedOptInMessage(optInMessage);
    }
  }, [brandName]);

  return (
    <div data-test="sms-smart-opt-in-preview">
      <FormLabel>{displayContent.labelSmsSmartOptInPreview}</FormLabel>
      <PreviewContent>
        <div style={deviceContainer}>
          <div style={messageHeader}>
            <div style={messageHeaderCenter}>
              <Avatar
                firstName=""
                size={AVATAR_SIZES.LARGE}
                color={AVATAR_COLORS.GREY}
                data-test="preview-avatar"
              >
                <Person width={20} height={20} />
              </Avatar>
            </div>
          </div>
          <div style={messageBody}>
            <div style={messageBodyMessageLabelSender}>Opt-in SMS</div>
            <div style={messageBodyMessageSender}>{brandedOptInMessage}</div>
            <div style={messageBodyMessageLabelResponder}>Legal disclaimer</div>
            <div style={messageBodyMessageResponder}>{legalDisclaimerMessage}</div>
          </div>
        </div>
      </PreviewContent>
    </div>
  );
};
